import {
  createStyles,
  FormControlLabel,
  Grid,
  makeStyles,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import _ from "lodash";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import CardCommon from "../../../../components/card/CardCommon";
import { CustomTheme } from "../../../../types/customTheme";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import { buttonColors } from "../../../../utils/enum";
import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import { updateLocationBasicInfo } from "../../../../services/locationApp/storeService";
import SwitchCommon from "../../../../components/switches/SwitchCommon";

const useStyles = (dimensions: any) =>
  makeStyles((theme: CustomTheme) =>
    createStyles({
      imgStyle: {
        borderRadius: "10px",
        border: `1px solid ${theme.palette.background.entity_border}`,
        width: "100%",
        height: "300px",
      },
      mapStyle: {
        paddingLeft: "12px",
        width: "100%",
        [theme.breakpoints.down("xs")]: {
          paddingLeft: "0px",
          marginTop: "8px",
        },
      },
      gridStyle: {
        paddingRight: "12px",
        [theme.breakpoints.down("xs")]: {
          paddingRight: "0px",
        },
      },
    }),
  );

export interface LocationDetailsProps {
  locationData: any;
  setLocationData: any;
  fetchBasicInfo: any;
}

/* This component displays 'location id', 'display name', 'business registration name', 
   and 'business trading name', and the 'location id' can be copied to the user. */
const ConfigDetails: React.FunctionComponent<LocationDetailsProps> = ({
  locationData,
  setLocationData,
  fetchBasicInfo,
}) => {
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isFeedToGoogle, setIsFeedToGoogle] = useState(true);

  useEffect(() => {
    setIsActive(locationData.isActive);
    setIsFeedToGoogle(locationData.isPushToGoogle || false);
  }, [locationData.isActive]);

  const handleRemoveLocation = async () => {
    try {
      let body: any = _.cloneDeep(locationData);

      body.isActive = !isActive; // Just remove the '?'
      const res = await updateLocationBasicInfo(
        locationData.id,
        body,
        body,
        "location",
      );
      setLocationData(res.data.data);
      setIsActive(body.isActive);
      setSuccess("Location successfully removed");
    } catch (error) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    }
  };

  const handleRemoveFeeToGoogleBusiness = async () => {
    try {
      let body: any = _.cloneDeep(locationData);

      body.isPushToGoogle = !isFeedToGoogle; // Just remove the '?'
      const res = await updateLocationBasicInfo(
        locationData.id,
        body,
        body,
        "location",
      );
      fetchBasicInfo()
      setLocationData(res.data.data);
      setIsFeedToGoogle(body.isPushToGoogle);
      setSuccess("Location successfully removed");
    } catch (error) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    }
  };

  return (
    <div style={{ marginBottom: "20px" }}>
      <CardCommon>
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              marginTop: "24px",
              marginLeft: "20px",
              marginRight: "20px",
              display: "flex",
              justifyContent: "start",
              marginBottom: "20px",
              alignItems: "center",
            }}
          >
            <FormControlLabel
              style={{ marginRight: "0px" }}
              control={<SwitchCommon />}
              checked={isActive}
              onChange={handleRemoveLocation}
              label="Location Live"
              labelPlacement="start"
            />
            <FormControlLabel
              style={{ marginRight: "0px" }}
              control={<SwitchCommon />}
              checked={isFeedToGoogle}
              onChange={handleRemoveFeeToGoogleBusiness}
              label="Feed to Google Business"
              labelPlacement="start"
            />
          </Grid>
        </Grid>
      </CardCommon>
    </div>
  );
};

export default withAuthority(ConfigDetails, Authorities.DASHBOARD_READ);
